export default function BgEllipse({ ...props }) {
  return (
    <div
      {...props}
      className={`w-[1087.432px] h-screen absolute bg-[radial-gradient(circle_closest-side_at_50%_50%,_rgba(42,188,241,0.3)_0%,_rgba(42,188,241,0)_100%)]
        ${props.className}`}
    ></div>
  );
}
